import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import Header from './components/Header';
import Footer from './components/Footer';
import FloatingCTA from './components/FloatingCTA';

// Pages
import Home from './pages/Home';
import Kvalitet from './pages/Kvalitet';
import Forsikring from './pages/Forsikring';
import FAQ from './pages/FAQ';
import Downloads from './pages/Downloads';
import NewsList from './pages/NewsList';
import NewsDetail from './pages/NewsDetail';
import About from './pages/About';
import Contact from './pages/Contact';
import FreightRates from './pages/FreightRates';
import VejtransportEuropa from './pages/VejtransportEuropa';
import Lagerhotel from './pages/Lagerhotel';
import Multimodal from './pages/Multimodal';
import Soefragt from './pages/Soefragt';
import ExpressKurér from './pages/ExpressKurér';
import DirekteBiler from './pages/DirekteBiler';
import CrossTrade from './pages/CrossTrade';
import Fragtkontoret from './pages/Fragtkontoret';
import Referencer from './pages/Referencer';
import ImportPage from './pages/ImportPage';
import ContainerKoersel from './pages/ContainerKoersel';
import LCL from './pages/LCL';
import ADRGods from './pages/ADRGods';
import Godsmaengder from './pages/Godsmaengder';
import Flyttegods from './pages/Flyttegods';
import FlyttegodsMoebler from './pages/FlyttegodsMoebler';
import PakkeforsendelsePrivate from './pages/PakkeforsendelsePrivate';
import SoefragtSydafrika from './pages/SoefragtSydafrika';
import SoefragtUSACanada from './pages/SoefragtUSACanada';
import RoadHaulage from './pages/RoadHaulage';
import GatewayUK from './pages/GatewayUK';
import HaulageShipping from './pages/HaulageShipping';
import Outsourcing from './pages/Outsourcing';
import Luftfragt from './pages/Luftfragt';
import Forbidden from './pages/Forbidden';
import NotFound from './pages/NotFound';

export default function App() {
  return (
    <div className="min-h-screen flex flex-col bg-slate-50 text-slate-900 font-sans antialiased selection:bg-[#0f2b48] selection:text-white">
      <ScrollToTop />
      <Header />
      <main className="flex-1">
        <Routes>
          {/* Main routes */}
          <Route path="/" element={<Home />} />
          <Route path="/kvalitet" element={<Kvalitet />} />
          <Route path="/forsikring" element={<Forsikring />} />
          <Route path="/spoergsmaal-svar-fragt" element={<FAQ />} />
          <Route path="/betingelser" element={<FAQ />} />
          <Route path="/kendskabdownloads" element={<Downloads />} />
          <Route path="/nyheder" element={<NewsList />} />
          <Route path="/nyheder/:slug" element={<NewsDetail />} />
          <Route path="/om-os" element={<About />} />
          <Route path="/kontakt" element={<Contact />} />
          <Route path="/dk/contact" element={<Contact />} />
          <Route path="/fragtrater" element={<FreightRates />} />
          <Route path="/enquiry" element={<FreightRates />} />

          {/* Transport services */}
          <Route path="/godstransport-i-europa" element={<VejtransportEuropa />} />
          <Route path="/vejtransport" element={<VejtransportEuropa />} />
          <Route path="/lager" element={<Lagerhotel />} />
          <Route path="/fragt-kombineret-transport" element={<Multimodal />} />
          <Route path="/containerfragt-soefragt" element={<Soefragt />} />
          <Route path="/soefragt" element={<Soefragt />} />
          <Route path="/eksprespakke" element={<ExpressKurér />} />
          <Route path="/kurer-forsendelser" element={<ExpressKurér />} />
          <Route path="/ekspres-kurer-i-direkte-lastbiler" element={<DirekteBiler />} />
          <Route path="/dedikerede-lastbiler" element={<DirekteBiler />} />
          <Route path="/cross-trade" element={<CrossTrade />} />
          <Route path="/fragtkontoret" element={<Fragtkontoret />} />
          <Route path="/godstransport-referencer" element={<Referencer />} />
          <Route path="/godstransport-private-kunder" element={<Referencer />} />
          <Route path="/import" element={<ImportPage />} />
          <Route path="/koersel-af-importcontainere" element={<ContainerKoersel />} />
          <Route path="/koersel-af-containere" element={<ContainerKoersel />} />
          <Route path="/lcl-less-container-load" element={<LCL />} />
          <Route path="/adr-gods" element={<ADRGods />} />
          <Route path="/farligt-gods" element={<ADRGods />} />
          <Route path="/godsmaengder-sendingsstoerrelser" element={<Godsmaengder />} />
          <Route path="/flyttegods" element={<Flyttegods />} />
          <Route path="/flyttegods-moebler-private" element={<FlyttegodsMoebler />} />
          <Route path="/pakkeforsendelse-private" element={<PakkeforsendelsePrivate />} />
          <Route path="/containerfragt-sydafrika" element={<SoefragtSydafrika />} />
          <Route path="/soefragt-sydafrika" element={<SoefragtSydafrika />} />
          <Route path="/soefragt-usa-canada" element={<SoefragtUSACanada />} />
          <Route path="/road-haulage-Holland-Belgium" element={<RoadHaulage />} />
          <Route path="/road-haulage-holland-belgium" element={<RoadHaulage />} />
          <Route path="/gateway-tofrom-ukscandinavia" element={<GatewayUK />} />
          <Route path="/haulage-and-shipping" element={<HaulageShipping />} />
          <Route path="/outsourcing" element={<Outsourcing />} />
          <Route path="/luftfragt-0" element={<Luftfragt />} />
          <Route path="/luftfragt" element={<Luftfragt />} />

          {/* Error pages */}
          <Route path="/403" element={<Forbidden />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
      <FloatingCTA />
    </div>
  );
}
